import React, { useCallback } from 'react';
import { TagsInput, TagsInputProps } from 'react-tag-input-component';
import styles from './index.module.scss';

type Props = { maxLength?: number } & TagsInputProps;

export const TagInput = ({ value, placeHolder, maxLength, ...rest }: Props) => {
  const checkMaxLength = useCallback(() => {
    if (maxLength && value) {
      return value.length < maxLength;
    }
    return true;
  }, [maxLength, value]);
  return (
    <TagsInput
      classNames={{ input: styles.tagInput, tag: styles.tag }}
      placeHolder={value?.length ? '' : placeHolder}
      value={value}
      beforeAddValidate={checkMaxLength}
      {...rest}
    />
  );
};
